"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("./safeInstanceOf");
/**
 * Check if the given object is HTMLOListElement
 * @param obj The object to check
 */
function isHTMLOListElement(obj) {
    return safeInstanceOf_1.default(obj, 'HTMLOListElement');
}
exports.default = isHTMLOListElement;
//# sourceMappingURL=isHTMLOListElement.js.map